import { useContext } from 'react';
import { GlobalContext } from '@/contexts/global-context';

/** 礼物多语言名称对象 */
export type GiftLocalizedName = {
  giftName: string;
  giftNameEn?: string | null;
  giftNameJa?: string | null;
  giftNameKo?: string | null;
  giftNameYue?: string | null;
};
const LANG_TO_GIFT_KEY: Record<string, keyof GiftLocalizedName> = {
  'zh-CN': 'giftName',
  'en-US': 'giftNameEn',
  'ko-KR': 'giftNameKo',
  'zh-TW': 'giftNameYue',
  'ja-JP': 'giftNameJa',
};
export const getGiftLocalizedName = (item: GiftLocalizedName, lang?: string) => {
  const key = lang ? LANG_TO_GIFT_KEY[lang] : undefined;
  const preferred = key && item[key] ? String(item[key]) : '';
  if (preferred) return preferred;
  return (
    item.giftNameEn ||
    item.giftName ||
    item.giftNameJa ||
    item.giftNameKo ||
    item.giftNameYue ||
    ''
  );
};

export const getLangName = (name?: string, nameEn?: string) => {
  const { lang } = useContext(GlobalContext);
  if (lang === 'zh-CN') {
    return name;
  }
  return nameEn || name;
};

/** 公告&分类多语言名称对象 */
export type LocalizedName = {
  name: string;
  nameEn?: string | null;
  nameJa?: string | null;
  nameKo?: string | null;
  nameYue?: string | null;
};

const LANG_TO_KEY: Record<string, keyof LocalizedName> = {
  'zh-CN': 'name',
  'en-US': 'nameEn',
  'ko-KR': 'nameKo',
  'zh-TW': 'nameYue',
  'ja-JP': 'nameJa',
};

/** 按当前语言取展示名称，支持多语言；为空时依次回退到 name、nameEn 等 */
export function getLocalizedName(
  item: LocalizedName,
  lang?: string
): string {
  const key = lang ? LANG_TO_KEY[lang] : undefined;
  const preferred = key && item[key] ? String(item[key]) : '';
  if (preferred) return preferred;
  return (
    item.nameEn ||
    item.name ||
    item.nameJa ||
    item.nameKo ||
    item.nameYue ||
    ''
  );
}
